import React from "react"

type Props = {
    menuParams: {
        option          : {
            icon            : string
            iconComponent?  : any
            label           : string
            disabled?       : boolean
        }
        selectedValue   : string
    }

    disabled?   : boolean

    hidePopover : callback
}

const debug = false
// const debug = "PopoverMenuCustomPopoverOptionButton"

export default function PopoverMenuCustomPopoverOptionButton(state: any, props: Props) {

    const option = props.menuParams.option

    const classes = Classes('option', {
        'with-icon'     : !!option.icon,
        'disabled'      : props.disabled || option.disabled,
    })

    debug && console.log(debug, 'render', props.menuParams.selectedValue)

    return (
        <div className={classes}>
            {option.icon && <div className={Classes("ico", option.icon)}/>}
            {option.iconComponent}
            <div className="label">{option.label}</div>
            <div className="submenu-arrow i5-big-angle-right"/>
        </div>
    )
}